import moment from "moment";
import { ModelBase } from "../abstract/model-base.model";
import { Authorization } from "../authorization/authorization.model";


export class UserAuthorization extends ModelBase {

    static override CLASS_NAME: string = 'UserAuthorization';

    private _authorization!: Authorization;
    private _dateFrom!: moment.Moment;
    private _dateTo!: moment.Moment;

    public get authorization(): Authorization {
        return this._authorization;
    }

    public set authorization(value: any) {
        this._setValue('_authorization', value, 'Authorization');
    }

    public get dateFrom(): moment.Moment {
        return this._dateFrom;
    }

    public set dateFrom(value: any) {
        this._setValue('_dateFrom', value, 'date');
    }

    public get dateTo(): moment.Moment {
        return this._dateTo;
    }

    public set dateTo(value: any) {
        this._setValue('_dateTo', value, 'date');
    }
}